import { AuthState } from "./auth.state";
import { ActionReducerMap } from '@ngrx/store';
import { AuthReducer } from "./auth.reducer";
import { AUTH_STATE } from "./auth.selector";

export interface CoreState {
    [AUTH_STATE]: AuthState
}

export const coreReducer: ActionReducerMap<CoreState> = {
    [AUTH_STATE]: AuthReducer
}

